/** @jsxImportSource @emotion/react */
/** @jsxFrag */

import { ChangeEvent, memo, useRef } from "react";
import { FormattedMessage } from "react-intl";

import { SerializedStyles } from "@emotion/react";
import { Typography } from "@material-ui/core";

import { Button, Img } from "..";

import { container, controllers, input, remove, img, error } from "./styles";

type El = HTMLInputElement | null;

interface InputRef {
  (el: El): void;
}

interface Props {
  name: string;
  value: string;
  helperText?: string;
  inputRef?: InputRef;
  accept?: string;
  disabled?: boolean;
  onChange: (url: string) => void;
  customizeStyle?: {
    container?: SerializedStyles;
    controllers?: SerializedStyles;
  };
}

const ImageUploader = ({
  name,
  value,
  helperText,
  inputRef,
  accept = "image/png, image/jpeg",
  disabled,
  onChange,
  customizeStyle,
}: Props): JSX.Element => {
  const inputEl = useRef<El>();

  const handleSelectChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const { files } = e.target;
    // eslint-disable-next-line compat/compat
    onChange(files?.length ? URL.createObjectURL(files[0]) : "");
  };

  const handleRemoveClick = (): void => {
    // @ts-expect-error
    inputEl.current.value = null;
    onChange("");
  };

  const setRef: InputRef = (el) => {
    if (!inputEl.current) inputEl.current = el;
    if (inputRef) inputRef(el);
  };
  return (
    <>
      <div css={customizeStyle?.container || container(disabled)}>
        <div css={customizeStyle?.controllers || controllers}>
          <input
            id={name}
            css={input}
            name={name}
            onChange={handleSelectChange}
            type="file"
            accept={accept}
            ref={setRef}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor={name}>
            <Button color="primary" variant="contained" component="span" css={{ width: "85px" }}>
              <FormattedMessage id="btn.select" />
            </Button>
          </label>
          {value && (
            <Button css={[remove, { width: "85px" }]} onClick={handleRemoveClick} variant="contained" color="error">
              <FormattedMessage id="btn.remove" />
            </Button>
          )}
        </div>
        {value && <Img css={img} src={value} alt="Preview" />}
      </div>
      {helperText && (
        <Typography css={error} variant="caption" color="error">
          {helperText}
        </Typography>
      )}
    </>
  );
};

export default memo(ImageUploader);
